import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for merging Tailwind CSS classes.
 * Combines clsx (conditional classes) with tailwind-merge (conflict resolution).
 *
 * @example
 * cn("px-2 text-red-500", isActive && "px-4 text-blue-500")
 * // Result: "px-4 text-blue-500" (conflicts resolved, conditionals handled)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
